import { loadModules } from "esri-loader";

const getArcGISBasemap = (basemap) => {
  return new Promise((resolve, reject) => {
    loadModules(["esri/Basemap"])
      .then(([Basemap]) => {
        let mapLayerPromise = getBasemapLayer(basemap);

        mapLayerPromise.then((mapLayer) => {
          let arcgisBasemap = new Basemap({
            baseLayers: [mapLayer],
            title: basemap.title,
            id: basemap.id,
            thumbnailUrl: basemap.thumbnailUrl,
            spatialReference: { wkid: 25833 },
          });

          resolve(arcgisBasemap);
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getBasemapLayer = (basemap) => {
  switch (basemap.type) {
    case "wms":
      return getWmsLayer(basemap.options);
    case "vector":
      return getVectorTileLayer(basemap.options);
    case "imagerylayer":
      return getImageryLayer(basemap.options);
    default:
      return getTileLayer(basemap.options);
  }
};

const getTileLayer = (layerOptions) => {
  return new Promise((resolve, reject) => {
    loadModules(["esri/layers/TileLayer"])
      .then(([TileLayer]) => {
        resolve(new TileLayer(layerOptions));
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getWmsLayer = (layerOptions) => {
  return new Promise((resolve, reject) => {
    loadModules(["esri/layers/WMSLayer"])
      .then(([WmsLayer]) => {
        resolve(new WmsLayer(layerOptions));
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getVectorTileLayer = (layerOptions) => {
  return new Promise((resolve, reject) => {
    loadModules(["esri/layers/VectorTileLayer"])
      .then(([VectorTileLayer]) => {
        resolve(new VectorTileLayer(layerOptions));
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getImageryLayer = (layerOptions) => {
  return new Promise((resolve, reject) => {
    loadModules(["esri/layers/ImageryLayer"])
      .then(([ImageryLayer]) => {
        resolve(new ImageryLayer(layerOptions));
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { getArcGISBasemap };
